// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"195":"abf3cc80e0c42dda60b8","260":"8420252036edbe3abfb0","732":"0fcfe3eb221b15368686"}[chunkId] + ".js";
};